/**
 * PCケースショーケース v2 — タブ切替 + 画像ギャラリー + 自動スライド + スクロールアニメーション
 */
(function () {
  'use strict';

  function initCaseShowcase(section) {
    var tabs = section.querySelectorAll('.pc-case-tab');
    var panels = section.querySelectorAll('.pc-case-panel');

    // タブ切替（タブがある場合のみ）
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('active'); });
        panels.forEach(function (p) {
          p.classList.remove('active');
          p.style.opacity = '0';
        });

        tab.classList.add('active');
        // 旧パネルのタイマーを全停止（非表示パネルで自動スライドが回り続けるのを防ぐ）
        panels.forEach(function (p) { stopAutoSlide(p); });
        var panel = panels[i];
        if (panel) {
          panel.classList.add('active');
          requestAnimationFrame(function () {
            panel.style.opacity = '1';
          });
          startAutoSlide(panel);
        }
      });
    });

    // 画像ギャラリー + 自動スライド（各パネル）
    panels.forEach(function (panel) {
      initGallery(panel);
      if (panel.classList.contains('active')) {
        startAutoSlide(panel);
      }
    });

    // スクロールアニメーション（JSからクラス付与 → CSSで非表示にならないフォールバック）
    if (section.hasAttribute('data-animate')) {
      section.classList.add('js-animate');
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });
      observer.observe(section);
    }
  }

  function initGallery(panel) {
    var thumbs = panel.querySelectorAll('.pc-case-thumb');
    var mainImg = panel.querySelector('.pc-case-main-img');

    if (!mainImg || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        panel.querySelectorAll('.pc-case-thumb').forEach(function (t) {
          t.classList.remove('active');
        });
        thumb.classList.add('active');

        mainImg.style.opacity = '0.3';
        var img = new Image();
        img.onload = function () {
          mainImg.src = thumb.dataset.full || thumb.src;
          mainImg.alt = thumb.alt || '';
          mainImg.style.opacity = '1';
        };
        img.src = thumb.dataset.full || thumb.src;

        // ユーザー操作のときのみ自動スライドを一時停止→再開
        // （自動スライド由来のclickでpauseすると4秒設定が実質10秒周期になるため区別する）
        if (panel._isAutoClick) {
          panel._isAutoClick = false;
        } else {
          pauseAutoSlide(panel);
        }
      });
    });
  }

  // 自動スライド
  function startAutoSlide(panel) {
    stopAutoSlide(panel);
    var thumbs = panel.querySelectorAll('.pc-case-thumb');
    if (thumbs.length < 2) return;

    panel._slideTimer = setInterval(function () {
      var current = panel.querySelector('.pc-case-thumb.active');
      var idx = Array.prototype.indexOf.call(thumbs, current);
      var next = (idx + 1) % thumbs.length;
      panel._isAutoClick = true; // clickハンドラ側でpauseをスキップさせる
      thumbs[next].click();
    }, 4000);
  }

  function stopAutoSlide(panel) {
    if (panel._slideTimer) {
      clearInterval(panel._slideTimer);
      panel._slideTimer = null;
    }
    if (panel._resumeTimer) {
      clearTimeout(panel._resumeTimer);
      panel._resumeTimer = null;
    }
  }

  function pauseAutoSlide(panel) {
    stopAutoSlide(panel);
    panel._resumeTimer = setTimeout(function () {
      startAutoSlide(panel);
    }, 6000);
  }

  // 初期化
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.pc-case-showcase').forEach(initCaseShowcase);
  });

  // Shopify テーマエディタ対応（global.js読込失敗時のReferenceError防止にtypeofで判定）
  if (typeof Shopify !== 'undefined' && Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('.pc-case-showcase');
      if (el) initCaseShowcase(el);
    });
  }
})();
